import {
  Briefcase,
  Calendar,
  FileText,
  Mail,
  Palette,
  Settings,
} from "lucide-react";
import { GetList } from "../../types/data-content";

export const getListInstitutionalWebsites = () => {
  let list: GetList[] = [
    {
      productId: "#STI02",
      titlePage: "Site Profissional para Imobiliárias e Corretores de Imóveis",
      titleCard: "Site Profissional para Imobiliárias e Corretores de Imóveis",
      cardDescription: `
        Site ideal para imobiliárias e corretores apresentarem imóveis, serviços, equipe e contato.
        <br /><br />
        <strong>Prazo de entrega:</strong> 15 a 20 dias úteis
      `,
      description: `
        <p>
          Destaque sua imobiliária no ambiente digital com um site moderno, responsivo e totalmente gerenciável.
          Nossa solução foi desenvolvida para corretores e empresas do setor imobiliário que desejam atrair mais clientes
          e facilitar o agendamento de visitas. 
        </p>
        <br />
      `,
      beneficiosDescription:
        "Com nosso painel de gerenciamento de conteúdo, você atualiza facilmente seu site sem precisar de conhecimentos técnicos. Personalize cores, logos, banners, imóveis, serviços, equipe, blog e contato de forma prática e rápida.",
      image: "/assets/site-institucional/02/site-institucional-02.jpg",
      link: "https://vivaview-realestate-template-hzfm.vercel.app/",
      price: "R$ 3.490,00",
      priceSale: "R$ 3.490,00",
      page: "/sites-institucionais/2",
      filter: "site-institucional",
      carousel: true,
      includedFeatures: [
        "Configuração de domínio e hospedagem",
        "Treinamento básico para gestão do sistema",
        "Painel administrativo (totalmente gerenciável)",
        "Suporte técnico durante a implementação",
        "Filtros de busca de imóveis",
        "Integração com WhatsApp para atendimento rápido",
      ],
      imagesCarousel: [
        {
          label: "Página inicial com Destaques de Imóveis",
          imgPath: "/assets/site-institucional/02/pagina-inicial.webp",
        },
        {
          label: "Página de Listagem de Imóveis",
          imgPath: "/assets/site-institucional/02/listagem-imoveis.jpg",
        },
        {
          label: "Página com detalhes do Imóvel",
          imgPath: "/assets/site-institucional/02/pagina-detalhes.jpg",
        },
        {
          label: "Página sobre a empresa",
          imgPath: "/assets/site-institucional/02/sobre-a-empresa.webp",
        },
        {
          label: "Página de contato",
          imgPath: "/assets/site-institucional/02/pagina-de-contato.webp",
        },
      ],
      features: [
        {
          icon: <Settings className="w-8 h-8 text-primary" />,
          title: "Gerenciamento Fácil",
          description:
            "Controle total de imóveis, serviços, equipe e conteúdo do seu site.",
        },
        {
          icon: <Palette className="w-8 h-8 text-primary" />,
          title: "Personalização Visual",
          description: "Defina cores, logos e banners de forma rápida.",
        },
        {
          icon: <Briefcase className="w-8 h-8 text-primary" />,
          title: "Seções Estratégicas",
          description:
            "Destaque imóveis, serviços, equipe e depoimentos de clientes.",
        },
        {
          icon: <Calendar className="w-8 h-8 text-primary" />,
          title: "Agendamento de Visitas",
          description:
            "Permita que clientes marquem visitas aos imóveis diretamente pelo site, de forma rápida e organizada.",
        },
        {
          icon: <Mail className="w-8 h-8 text-primary" />,
          title: "Contato e Localização",
          description: "Facilite a comunicação e mostre onde sua empresa está.",
        },
        {
          icon: <Settings className="w-8 h-8 text-primary" />,
          title: "Painel Administrativo Intuitivo",
          description:
            "Gerencie seu site de forma simples e prática, com total controle de conteúdo e personalização.",
        },
      ],
      descricaoFuncionamento: "Visualize as principais telas do site e descubra a experiência do usuário",
    },
    {
      productId: "#STI01",
      titlePage: "Site Profissional para Empresas de Construção e Reformas",
      titleCard: "Site Profissional para Empresas de Construção e Reformas",
      cardDescription: `
        Site para apresentar serviços, produtos, sobre a empresa, blog e contato.
        <br /><br />
        <strong>Prazo de entrega:</strong> de 7 a 15 dias úteis
      `,
      description: `
        <p>
          Potencialize sua presença online com nossos sites institucionais!. Com designs modernos e responsivos, garantimos que sua instituição se destaque na web. Nossa plataforma intuitiva permite atualizações fáceis. Adquira agora e transforme sua comunicação digital!
        </p>
      `,
      beneficiosDescription:
        "Com nosso Painel de Gerenciamento de Conteúdo, você atualiza facilmente seu site sem precisar de conhecimentos técnicos. Controle cores, logos, banners, seções de serviços, portfólio, equipe, blog e contato, tudo de forma prática e rápida.",
      exibirFidelidade: true,
      planosValues: [
        {
          type: "",
          value: "",
          valueInstallments: "",
          form: `
           
          `,
          linkPix: "https://pag.ae/7-X6iCAB7",
          info: `
            <p><strong>Inclui:<strong></p>
            <ul>
              <li>Configuração de domínio e hospedagem</li>
              <li>Parcelamos em até 12x no cartão de crédito</li>
            </ul>
          <a href="https://api.whatsapp.com/send?phone=5511964914546" target="_blank" class="CTA">👉 Vamos conversar</a>`,
        },
      ],
      image: "/assets/site-institucional/01/site-institucional-01.jpg",
      video: "",
      link: "https://yellow-baboon-220244.hostingersite.com/",
      formulario:
        "https://docs.google.com/forms/d/e/1FAIpQLSfYNz_yNpAvmZhGy6fpxtL4hgTnakswmkehJ-AaTw9l5wZDXQ/viewform?usp=sf_link",
      price: "R$ 59,90/mês",
      priceSale: "R$ 3.500,00",
      page: "/sites-institucionais/1",
      filter: "site-institucional",
      carousel: true,
      includedFeatures: [
        "Configuração de domínio e hospedagem",
        "Manual de uso",
        "Painel administrativo em WordPress (totalmente gerenciável)",
        "Suporte técnico durante a implementação",
        "Treinamento básico para gestão do sistema",
        "Design responsivo otimizado",
      ],
      imagesCarousel: [
        {
          label: "Gerenciamento de Menu",
          imgPath: "/assets/site-institucional/01/menu.webp",
        },
        {
          label: "Gerenciamento de Blogs",
          imgPath: "/assets/site-institucional/01/blogs.webp",
        },
        {
          label: "Gerenciamento de Clientes",
          imgPath: "/assets/site-institucional/01/clientes.webp",
        },
      ],
      features: [
        {
          icon: <Settings className="w-8 h-8 text-primary" />,
          title: "Gerenciamento Fácil",
          description:
            "Controle total de itens, seções e conteúdo do seu site.",
        },
        {
          icon: <Palette className="w-8 h-8 text-primary" />,
          title: "Personalização Visual",
          description: "Defina cores, logos e banners de forma rápida.",
        },
        {
          icon: <Briefcase className="w-8 h-8 text-primary" />,
          title: "Seções Estratégicas",
          description: "Destaque portfólio, serviços, equipe e clientes.",
        },
        {
          icon: <FileText className="w-8 h-8 text-primary" />,
          title: "Conteúdo e Blog",
          description:
            "Compartilhe informações relevantes e atraia visitantes.",
        },
        {
          icon: <Mail className="w-8 h-8 text-primary" />,
          title: "Contato e Localização",
          description: "Facilite a comunicação e mostre onde sua empresa está.",
        },
        {
          icon: <Settings className="w-8 h-8 text-primary" />,
          title: "Manual de Uso",
          description:
            "Aprenda a gerenciar seu site de forma prática e eficiente.",
        },
      ],
      descricaoFuncionamento: "Interface administrativa intuitiva e poderosa",
    },
  ];

  return list;
};
